<app-secondary-button title="PROCESS_PARAMETER_DEFAULTS" icon="pi pi-cog" size="small" [disable]="!processKey()"
  (action)="open()" />
<p-dialog [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true" [draggable]="false"
  [resizable]="false" [header]="'PROCESS_PARAMETER_DEFAULTS' | translate" [style]="{ width: 'min(54rem, 96vw)' }" appendTo="body">
  <p class="hint">{{ 'PROCESS_PARAMETER_DEFAULTS_HINT' | translate }}</p>
  @if (loading()) {
    <app-loading [loading]="true" />
  } @else if (response()) {
    <div class="defaults-fields">
      @for (field of fields(); track field.name) {
        <section class="default-field">
          <app-checkbox [ngModel]="field.configured" (ngModelChange)="configure(field, $event)"
            [label]="field.labelKey" [disabled]="saving()" />
          @if (field.configured) {
            @switch (field.type) {
              @case ('regions') {
                <app-region-dictionary-select [model]="field.regions" (modelChange)="setValue(field, $event)" [label]="field.labelKey" />
              }
              @case ('checkbox') {
                <app-checkbox [ngModel]="field.checked" (ngModelChange)="setValue(field, $event)" label="PROCESS_DEFAULTS_VALUE" />
              }
              @case ('number') {
                <msf-input [model]="field.value" (modelChange)="setValue(field, $event)" type="number" [min]="field.min ?? -1000000000"
                  [label]="'PROCESS_DEFAULTS_VALUE'" />
              }
              @case ('select') {
                <msf-select [model]="field.value" (modelChange)="setValue(field, $event)" [options]="field.options"
                  optionLabel="label" optionValue="id" translateBy="locale" />
              }
              @case ('checks') {
                @for (option of field.options; track option.id) {
                  <app-checkbox [ngModel]="option.selected" (ngModelChange)="setCheck(field, option.id, $event)" [label]="option.label" />
                }
              }
              @default {
                <msf-input [model]="field.value" (modelChange)="setValue(field, $event)" [label]="'PROCESS_DEFAULTS_VALUE'" />
              }
            }
            @if (field.helpKey) { <small>{{ field.helpKey | translate }}</small> }
          } @else { <small>{{ 'PROCESS_DEFAULTS_UNCONFIGURED' | translate }}</small> }
        </section>
      }
    </div>
    <app-textarea [ngModel]="otherJson()" (ngModelChange)="setOtherJson($event)" [label]="'PROCESS_DEFAULTS_OTHER_JSON'"
      [rows]="8" [showCharacterCount]="false" />
    <small>{{ 'PROCESS_DEFAULTS_JSON_HELP' | translate }}</small>
  }
  @if (error() || fieldError() || jsonError()) {
    <p class="error" role="alert">{{ (error() || fieldError() || jsonError()) | translate }}</p>
  }
  <ng-template pTemplate="footer">
    <div class="actions">
      @if (!response() && !loading()) { <app-secondary-button title="Retry" icon="pi pi-refresh" (action)="load()" /> }
      <app-secondary-button title="PROCESS_DEFAULTS_CLEAR" icon="pi pi-undo" [disable]="!response()?.hasOverride || saving() || loading()"
        (action)="clear()" />
      <app-primary-button title="Save" icon="pi pi-save" [disable]="!canSave()" [loading]="saving()" (action)="save()" />
    </div>
  </ng-template>
</p-dialog>
